module.exports = __webpack_public_path__ + "static/media/02_Mascotte_pluie.9031f3a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/02_Mascotte_pluie.svg
// module id = 758
// module chunks = 0